import { notify } from "@general-backoffice/core/index";

type NotifyId = string | number | undefined;
type NotifyType = "error" | "success" | "warning" | "default" | "info";
type NotifyRender = string | number | React.ReactNode;
type NotifyOptions = Record<string, unknown>;

const notifyLoadingUpdate = (id: NotifyId, render: NotifyRender, type: NotifyType, options: NotifyOptions = {}) => {
  return notify.update(id, {
    render,
    type,
    isLoading: false,
    autoClose: null,
    className: "animation-shake",
    ...options,
  });
};

const notifyLoadingToError = (id: NotifyId, render: NotifyRender, options: NotifyOptions = {}) =>
  notifyLoadingUpdate(id, render, "error", options);
const notifyLoadingToSuccess = (id: NotifyId, render: NotifyRender, options: NotifyOptions = {}) =>
  notifyLoadingUpdate(id, render, "success", options);
const notifyLoadingToWarning = (id: NotifyId, render: NotifyRender, options: NotifyOptions = {}) =>
  notifyLoadingUpdate(id, render, "warning", options);
const notifyLoadingToDefault = (id: NotifyId, render: NotifyRender, options: NotifyOptions = {}) =>
  notifyLoadingUpdate(id, render, "default", options);
const notifyLoadingToInfo = (id: NotifyId, render: NotifyRender, options: NotifyOptions = {}) =>
  notifyLoadingUpdate(id, render, "info", options);
const notifyLoadingToLoading = (id: NotifyId, render: NotifyRender, options: NotifyOptions = {}) =>
  notify.update(id, { render, ...options });

export {
  notifyLoadingToDefault,
  notifyLoadingToError,
  notifyLoadingToInfo,
  notifyLoadingToLoading,
  notifyLoadingToSuccess,
  notifyLoadingToWarning,
  notifyLoadingUpdate,
};
